import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'

import './Contacts.css'
import template from './Contacts.jinja'


var Contacts = BaseView.extend({
    el: '.Contacts',

    initialize () {
        this.$title = this.$('.Contacts-address')
        this.$footer = this.$('.Contacts-footer')
        this.$list = this.$('.Contacts-list')
    },

    activateTitle (options) {
        var self = this

        return $.Velocity.animate(this.$title[0], {opacity: 1}, _.extend({
            duration: 1500,
            complete () {
                self.$title.removeClass('isNotActive')
            }
        }, options))
    },

    deactivateTitle(options) {
        return $.Velocity.animate(this.$title[0], {opacity: 0}, _.extend({duration: 1000}, options))
    },

    activateInfo(options) {
        return $.Velocity.animate([this.$footer[0], this.$list[0]], {opacity: 1}, _.extend({duration: 800}, options))
    },

    deactivateInfo(options) {
        return $.Velocity.animate([this.$footer[0], this.$list[0]], {opacity: 0}, _.extend({duration: 800}, options))
    }
})

export default Contacts


// WEBPACK FOOTER //
// ./assets/app/front/components/Contacts/Contacts.js